import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-turns-reports-smssent-card',
  templateUrl: './turns-reports-smssent-card.component.html',
  styleUrls: ['./turns-reports-smssent-card.component.scss']
})
export class TurnsReportsSmssentCardComponent implements OnInit {

  @Input() value;

  constructor() { }

  ngOnInit() {
  }

}
